/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsPackageListItem
 */
export interface IdentityMelcoModelsPackageListItem {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPackageListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPackageListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPackageListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPackageListItem
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPackageListItem
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPackageListItem
     */
    credits?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityMelcoModelsPackageListItem
     */
    is_sellable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPackageListItem
     */
    validity_duration?: number;
}

export function IdentityMelcoModelsPackageListItemFromJSON(json: any): IdentityMelcoModelsPackageListItem {
    return IdentityMelcoModelsPackageListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsPackageListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsPackageListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'credits': !exists(json, 'credits') ? undefined : json['credits'],
        'is_sellable': !exists(json, 'is_sellable') ? undefined : json['is_sellable'],
        'validity_duration': !exists(json, 'validity_duration') ? undefined : json['validity_duration'],
    };
}

export function IdentityMelcoModelsPackageListItemToJSON(value?: IdentityMelcoModelsPackageListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'description': value.description,
        'price': value.price,
        'credits': value.credits,
        'is_sellable': value.is_sellable,
        'validity_duration': value.validity_duration,
    };
}


